<svelte:options customElement="clw-icon-autoplay" />

<script lang="ts">
    export let fillColor = 'white';
</script>

<svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_2092_120339)">
        <path
            d="M18.5748 16.868C16.9628 19.0916 14.3977 20.2997 11.7851 20.2484C7.58078 20.1658 4.01537 16.7256 3.76406 12.4829C3.49241 7.89691 7.19257 3.85067 11.7851 3.75189C14.0882 3.70236 16.4781 4.62737 18.0843 6.28491C18.0922 6.29306 18.0999 6.30126 18.1076 6.30951C18.4842 6.07598 18.8066 5.89737 19.0768 5.76104C19.6552 5.46919 20.2308 5.85524 20.2456 6.50586C20.2637 7.30446 20.2328 8.5039 20.0333 10.0846C19.9518 10.7302 19.3451 11.1695 18.7105 11.0423C17.1567 10.7309 16.0159 10.3797 15.2686 10.1091C14.6598 9.88861 14.4784 9.21706 14.9372 8.75805C15.1563 8.53876 15.4345 8.28141 15.7853 7.98817C15.7743 7.9758 15.7635 7.96327 15.7529 7.95059C14.7603 6.76542 13.5799 6.05634 11.7851 6.1097C8.47065 6.20829 5.84024 9.1772 6.11347 12.4829C6.35772 15.4384 8.85087 17.8088 11.7851 17.8906C13.5871 17.9409 15.3627 17.1513 16.5299 15.6788C16.882 15.2345 17.3638 14.8875 17.8792 15.1204C17.9742 15.1633 18.077 15.2159 18.1874 15.28C18.2978 15.3441 18.3945 15.4074 18.479 15.4687C18.9373 15.8011 18.9076 16.4088 18.5748 16.868Z"
            fill={fillColor}
        />
        <path
            d="M12.1564 9.46605L10.6246 14.8875H9.1123L11.3391 8.28748H12.2837L12.1564 9.46605ZM13.3652 14.8875L11.8236 9.46605L11.6817 8.28748H12.6409L14.8873 14.8875H13.3652ZM13.4191 12.4261V13.5276H10.2037V12.4261H13.4191Z"
            fill={fillColor}
        />
    </g>
    <defs>
        <clipPath id="clip0_2092_120339">
            <rect width="16.5" height="16.5" fill={fillColor} transform="translate(3.75 3.75)" />
        </clipPath>
    </defs>
</svg>
